module.exports = __webpack_public_path__ + "whatsapp-icon-md.png?150d9d24a85535d77d25d8090b653a0d";